function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

document.addEventListener('click', function (e) {
  if (e.target.closest('[data-cart-drawer-open]')) {
    e.preventDefault();
    openCartDrawer();
  }
  if (e.target.closest('[data-cart-drawer-close]')) {
    closeCartDrawer();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') closeCartDrawer();
});

function refreshCartDrawer(sections) {
  const newDrawerHtml = sections['cart-drawer'];
  if (newDrawerHtml) {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(newDrawerHtml, 'text/html');
    const newDrawer = newDoc.getElementById('cart-drawer');
    const oldDrawer = document.getElementById('cart-drawer');
    if (newDrawer && oldDrawer) {
      if (oldDrawer.classList.contains('is-open')) {
        newDrawer.classList.add('is-open');
      }
      oldDrawer.replaceWith(newDrawer);
    }
  }

  const bubbleHtml = sections['cart-icon-bubble'];
  const bubble = document.getElementById('cart-icon-bubble');
  if (bubbleHtml && bubble) {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(bubbleHtml, 'text/html');
    const newBubble = newDoc.getElementById('cart-icon-bubble');
    if (newBubble) bubble.replaceWith(newBubble);
  }
}

function refreshHeaderCartCount(sections) {
  const headerHtml = sections['header'];
  if (!headerHtml) return;
  const parser = new DOMParser();
  const newDoc = parser.parseFromString(headerHtml, 'text/html');
  const newHeader = newDoc.querySelector('.header');
  const oldHeader = document.querySelector('.header');
  if (newHeader && oldHeader) {
    oldHeader.replaceWith(newHeader);
  }
}

subscribe(PUB_SUB_EVENTS.cartIncrease, function (data) {
  function applyCartUpdate(sections) {
    refreshCartDrawer(sections);
    refreshHeaderCartCount(sections);
    setTimeout(function () {
      openCartDrawer();
    });
  }

  if (data && data.cartData && data.cartData.sections) {
    applyCartUpdate(data.cartData.sections);
    return;
  }

  // Fallback: fetch sections ourselves if no cart data came with the event
  fetch(`${window.location.pathname}?sections=cart-drawer,header`)
    .then(function (res) { return res.json(); })
    .then(function (sections) {
      applyCartUpdate(sections);
    })
    .catch(function (err) { console.error('Cart drawer refresh failed', err); });
});

document.addEventListener('click', function (e) {
  const changeBtn = e.target.closest('[data-cart-change]');
  if (changeBtn && !changeBtn.disabled) {
    const quantity = Number(changeBtn.dataset.quantity);

    if (quantity === 0) {
      const item = changeBtn.closest('.cart-drawer__item');
      if (item) {
        item.querySelector('[data-cart-drawer-qty]').hidden = true;
        item.querySelector('[data-cart-drawer-confirm]').hidden = false;
      }
      return;
    }

    performCartChange(changeBtn, quantity);
    return;
  }

  const confirmBtn = e.target.closest('[data-cart-remove-confirm]');
  if (confirmBtn) {
    performCartChange(confirmBtn, 0);
    return;
  }

  const cancelBtn = e.target.closest('[data-cart-remove-cancel]');
  if (cancelBtn) {
    const item = cancelBtn.closest('.cart-drawer__item');
    if (item) {
      item.querySelector('[data-cart-drawer-confirm]').hidden = true;
      item.querySelector('[data-cart-drawer-qty]').hidden = false;
    }
  }
});

function performCartChange(btn, quantity) {
  if (btn.disabled) return;
  btn.disabled = true;

  fetch(`${window.routes.cart_change_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(btn.dataset.line),
      quantity: quantity,
      sections: 'cart-drawer,header',
      sections_url: window.location.pathname
    })
  })
    .then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    })
    .then(function (result) {
      if (!result.ok) {
        showCartDrawerError(result.data.message || 'That quantity is not available.');
        return;
      }
      refreshCartDrawer(result.data.sections);
      refreshHeaderCartCount(result.data.sections);
    })
    .catch(function (err) { console.error('Cart update failed', err); })
    .finally(function () { btn.disabled = false; });
}

function showCartDrawerError(message) {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  let errorEl = drawer.querySelector('.cart-drawer__error');
  if (!errorEl) {
    errorEl = document.createElement('p');
    errorEl.className = 'cart-drawer__error';
    drawer.querySelector('.cart-drawer__panel').prepend(errorEl);
  }
  errorEl.textContent = message;
  errorEl.hidden = false;
  clearTimeout(showCartDrawerError._timeout);
  showCartDrawerError._timeout = setTimeout(function () {
    errorEl.hidden = true;
  }, 4000);
}